import { QuestionProvider } from '../../context/QuestionContext/QuestionContext'
import QuestionPage from './QuestionPage'
import ISTQuestionPage from './ISTQuestionPage'
import { useModule } from '../../context/ModuleContext/ModuleContext'
import KraepQuestionPage from './KraepQuestionPage'

const QuestionContainer = () => {
  const { modules } = useModule()
  const moduleName = modules.nama_modul?.trim().toLowerCase()

  const istModules = ['intelligenz-struktur-test (ist)', 'ist']
  const kraepModules = ['kraepelin test', 'kraepelin']

  const isIST = istModules.includes(moduleName)
  const isKraeplin = kraepModules.includes(moduleName)

  return (
    <QuestionProvider>
      {isIST && <ISTQuestionPage />}
      {isKraeplin && <KraepQuestionPage />}
      {!isIST && !isKraeplin && <QuestionPage />}
    </QuestionProvider>
  )
}

export default QuestionContainer
